export function validationBet(value) {
  let error;
  if (!value) {
    error = 'Required';
  } else if (value === '0._' || value === '0.' || value === '0') {
    error = 'Required';
  }
  return error;
}
